<template>
  <div class="tutor-page">
    <div class="top-menu">
      <div class="top">人工智能与机器视觉实验室</div>
      <div class="blank"></div>
      <div class="menu">
        <div class="menu-detail" @click="jumpToHome">首页</div>
        <div class="menu-detail" @click="jumpToTutor">导师风采</div>
        <div class="menu-detail" @click="jumpToTeam">科研团队</div>
        <div class="menu-detail" @click="jumpToPaper">论文成果</div>
        <div class="menu-detail" @click="jumpToHonor">获奖情况</div>
        <div class="menu-detail" @click="jumpToDownload">文件下载</div>
        <div class="menu-detail" style="font-family: 'Times New Roman', Times, serif;" @click="jumpToInnovation"> Innovation </div>
        <div class="menu-detail" style="font-family: 'Times New Roman', Times, serif;" @click="jumpToService"> Service </div>
        <div class="menu-detail" style="font-family: 'Times New Roman', Times, serif;" @click="jumpToInfluence_Contribution"> Influence and Contribution </div>
      </div>
    </div>

    <div class="blank"></div>
    <div class="page-content">
      <div class="informations">

       <div class="download">
         <!-- <a :href=""></a> -->
         <!-- <a href="519-1.docx" target="_self" style="user-select: auto;">硕博研究生毕业答辩流程及资料归档</a> -->
         <ol style="text-align: left; line-height: 3em; user-select: auto;">
           <li>
             <span style="color: rgb(0, 0, 0); font-family: 微软雅黑, 'Microsoft YaHei'; font-size: 16px; text-decoration: none; user-select: auto;"
              @click.stop="openPassword(1, 'pdf_5191')"
              >
              <span title="硕博研究生毕业答辩流程及资料归档" :href="pdf_5191" style="user-select: auto" download="519-1.docx">硕博研究生毕业答辩流程及资料归档</span>
              </span>
           </li>
           <li>
             <span style="color: rgb(0, 0, 0); font-family: 微软雅黑, 'Microsoft YaHei'; font-size: 16px; text-decoration: none; user-select: auto;"
              @click.stop="openPassword(2, 'pdf_5192')"
              >
              <span title="研究生入学学习计划" :href="pdf_5192" style="user-select: auto;" download="519-2.pdf">研究生学习计划</span>
              </span>
           </li>
           <li>
             <span style="color: rgb(0, 0, 0); font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 16px; text-decoration: none; user-select: auto;"
             @click.stop="openPassword(3, 'pdf_5193')"
             >
               <span title="研究生读文献基本方法" :href="pdf_5193" style="user-select: auto;" download="519-3.pdf">研究生读文献基本方法</span>
             </span>
           </li>
           <li>
             <span style="color: rgb(0, 0, 0); font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 16px; text-decoration: none; user-select: auto;"
             @click.stop="openPassword(4, 'pdf_5194')"
             >
               <span title="519实验室云cpu使用说明" :href="pdf_5194" style="user-select: auto;" download="519-4.pdf">519实验室云cpu使用说明</span>
             </span>
           </li>
           <li>
             <span style="color: rgb(0, 0, 0); font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 16px; text-decoration: none; user-select: auto;"
             @click.stop="openPassword(5, 'pdf_5195')"
             >
               <span title="519实验室分组" :href="pdf_5195" style="user-select: auto;" download="519-5.pdf">519实验室分组</span>
             </span>
           </li>
           <li>
             <span style="color: rgb(0, 0, 0); font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 16px; text-decoration: none; user-select: auto;"
             @click.stop="openPassword(6, 'pdf_5196')"
             >
               <span title="研究生过程管理" :href="pdf_5196" style="user-select: auto;" download="519-6.pdf">研究生过程管理</span>
             </span>
           </li>
           <li>
             <span style="color: rgb(0, 0, 0); font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 16px; text-decoration: none; user-select: auto;"
             @click.stop="openPassword(7, 'pdf_5197')"
             >
               <span title="年终汇报模板" :href="pdf_5197" style="user-select: auto;" download="model.pptx">年终汇报模板</span>
             </span>
           </li>
           <li>
             <span style="color: rgb(0, 0, 0); font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 16px; text-decoration: none; user-select: auto;"
             @click.stop="openPassword(8, 'pdf_5198')"
             >
               <span title="开题报告模板" :href="pdf_5198" style="user-select: auto;" download="519-8.docx">开题报告模板</span>
             </span>
           </li>
           <li>
             <span style="color: rgb(0, 0, 0); font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 16px; text-decoration: none; user-select: auto;"
             @click.stop="openPassword(9, 'pdf_5199')"
             >
               <span title="IEEE期刊作者与基金模板" :href="pdf_5199" style="user-select: auto;" download="519-9.rar">IEEE期刊作者与基金模板</span>
             </span>
           </li>
           <li>
             <span style="color: rgb(0, 0, 0); font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 16px; text-decoration: none; user-select: auto;"
             @click.stop="openPassword(10, 'pdf_519A')"
             >
               <span title="专利模板" :href="pdf_519A" style="user-select: auto;" download="519-A.rar">专利模板</span>
             </span>
           </li>
           <li>
             <span style="color: rgb(0, 0, 0); font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 16px; text-decoration: none; user-select: auto;"
             @click.stop="openPassword(11, 'pdf_519B')"
             >
               <a title="硕博研究生学位论文撰写及答辩流程" :href="pdf_519B" style="user-select: auto;" download="519-B.rar">硕博研究生学位论文撰写及答辩流程</a>
             </span>
           </li>
           <li>
             <span style="color: rgb(0, 0, 0); font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 16px; text-decoration: none; user-select: auto;"
             @click.stop="openPassword(12, 'pdf_519C')"
             >
               <a title="中期答辩ppt模板" :href="pdf_519C" style="user-select: auto;" download="519-C.rar">中期答辩ppt模板</a>
             </span>
           </li>
         </ol>
       </div>
       
      </div>

      <div class="blank"></div>
      
    </div>
         <div class="footer">Copyright© 2019 All Rights Reserved. 陕西科技大学人工智能与机器视觉实验室版权所有  </div>

    <el-dialog
      title="请输入密码"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div>
        <el-form
          :model="form"
          ref="form"
          label-width="100px"
          class="demo-dynamic"
        >
          <el-form-item
            prop="password"
            label="密码"
            :rules="[
              { required: true, message: '请输入密码', trigger: 'blur' },
            ]"
          >
            <el-input v-model="form.password" type="password"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submit"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        path: process.env.BASE_URL,
        pdf_5191: "../download/519-1.docx",
        pdf_5192: "../download/519-2.pdf",
        pdf_5193: "../download/519-3.pdf",
        pdf_5194: "../download/519CPU.pdf",
        pdf_5195: "../download/519.pdf",
        pdf_5196: "../download/519-6.pdf",
        pdf_5197: "../download/model.pptx",
        pdf_5198: "../download/519-8.docx",
        pdf_5199: "../download/519-9.rar",
        pdf_519A: "../download/519-A.rar",
        pdf_519B: "../download/519-B.docx",
        pdf_519C: "../download/519-C.pptx",
        dialogVisible: false,
        password: {
          1: "SUST2b519",
          2: "SUST2b519",
          3: "SUST2b519",
          4: "SUST2b519",
          5: "SUST2b519",
          6: "SUST2b519",
          7: "SUST2b519",
          8: "SUST2b519",
          9: "SUST2b519",
          10: "SUST2b519",
          11: "SUST2b519",
          12: "SUST2b519",
        },
        form: {
          password: ''
        },
        dialogType: '',
        fileName: ''
      };
    },
    methods: {
      handleClose() {
      this.dialogVisible = false;
    },
    openPassword(type,fileName) {
      this.form.password = ''
      this.dialogType = type
      this.fileName = fileName
      this.dialogVisible = true;
    },
    submit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let validPassword = this.password[this.dialogType]
          if (validPassword == this.form.password) {
            const link = document.createElement('a')
            link.setAttribute('download', this.fileName)
            link.href = this[this.fileName]
            link.click()
            this.dialogVisible = false;
          } else {
            this.$message.info('密码不正确!')
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
      jumpToHome() {
        this.$router.push({
          name: "home",
        });
      },
      jumpToTutor() {
        this.$router.push({
          name: "tutor",
        });
      },
      jumpToTeam() {
        this.$router.push({
          name: "team",
        });
      },
      jumpToPaper() {
        this.$router.push({
            name: "paper",
        });
      },
      jumpToHonor() {
                this.$router.push({
                    name: "honor",
                });
            },
      jumpToDownload() {
        this.$router.push({
            name: "download",
        });
      },
      jumpToInnovation() {
        this.$router.push({
            name: "innovation",
        });
      },
      jumpToService() {
        this.$router.push({
            name: "service",
        });
      },
      jumpToInfluence_Contribution() {
        this.$router.push({
          name: "influence_contribution",
        });
      },
    },
  };
</script>

<style scoped>
  .tutor-page {
    width: 100%;
    height: 100%;
    background-color: #fffef9;
    display: flex;
    flex-direction: column;
  }

  .top-menu {
    width: 100%;
  }

  .top {
      height: 12vh;
      width: 100%;
      background-image: url("../../assets/bg.jpg");
      color: white;
      font-size: 2.1vmax;
      font-weight: 500;
      line-height: 12vh;
      text-align: center;
      letter-spacing: 1vmax;
  }

  .menu {
      display: flex;
      flex-direction: row;
      height: 5vh;
      font-size: 1.1vmax;
      line-height: 5vh;
      padding-left: 3.1vmax;
      background-color: #dfe8ed;
  }

  .menu-detail {
    padding: 0 0.5vmax;
    cursor: pointer;
  }

  .blank {
    background-color: #dfe8ed;
    height: 3px;
    width: 100%;
  }

  .menu-detail:hover {
    background-color: #dfe8ed;
  }

  .page-content {
    width: 100%;
  }

  .informations {
    display: flex;
    flex-direction: row;
    height: auto;
    padding: 30px 0;
  }

  .tutor-img {
    /*小图
         height: 200px;
        width: 150px; 
        margin: 0 80px;*/
    /* 大图 */
    margin: 20px 50px 0 100px;
  }

  .tutor-information {
    display: flex;
    flex-direction: column;
  }

  .tutor-name {
    font-size: 20px;
    padding: 30px 0;
  }

  .tutor-information-content {
    display: flex;
    flex-direction: row;
  }

  .tutor-information-list {
    display: flex;
    flex-direction: column;
  }

  .tutor-information-word {
    line-height: 3vw;
    font-size: 0.8vmax;
  }

  .tutor-direction-list {
    display: flex;
    flex-direction: column;
    padding-left: 200px;
  }

  .tutor-direction-word {
    line-height: 3vw;
    font-size: 0.8vmax;
  }

  .contact {
    padding: 30px 0 0 0px;
  }

  .contact-title {
    padding-right: 10px;
  }

  .contact-word {
    line-height: 3vw;
    font-size: 0.8vmax;
  }

  .introduction {
    display: flex;
    flex-direction: column;
    padding: 0 100px;
    padding-top: 20px;
  }

  .introduction-title {
    /* padding:0px 100px; */
    line-height: 50px;
    font-size: 22px;
  }

  .introduction-word {
    line-height: 30px;
    padding-left: 20px;
    padding-bottom: 25px;
  }
  .icon-yuandianzhong {
        color: #8a9098;
    }
    .footer{
        height: 70px;
        background-color: 	#575D64;
        color: #ffffff;
        line-height: 70px;
        text-align: center;
        margin-top: 30px;
        width: 100%;
        position: fixed;
        bottom: 0;
    }
span span{
  color: #0000ee;
  text-decoration: underline;
  cursor: pointer;
}
</style>